export default "ui-brandName = { -product-name }\r\nui-callout-closeButton =\r\n  .aria-label = Close\r\nui-tabAriaPrefix = Tab:\r\n";